// import { useEffect, useState } from "react";
// import HeroSection from "./HeroSection";
// import axios from "../../axios";

// function HomeTitle() {
//   const [heroSlides, setHeroSlides] = useState([]);

//   useEffect(() => {
//     axios.get("/banners")
//       .then((res) => {
//         const slides = res.data.map((banner) => ({
//           image: banner.image_url,
//           textLine1: banner.title?.split(" ")[0] || "",   // First word
//           textLine2: banner.title?.split(" ").slice(1).join(" ") || "",  // Rest of title
//         }));
//         setHeroSlides(slides);
//       })
//       .catch((err) => {
//         console.error("Failed to load banners:", err);
//       });
//   }, []);

//   return (
//     <div className="homepage bg-white">
//       <div>
//         {heroSlides.length > 0 && <HeroSection images={heroSlides} />}
//       </div>

//       <section className="partner-section d-flex flex-column justify-content-center align-items-center text-center py-5">
//         <div className="container bg-white home-title">
//           <h1 className="fw-normal">Your Trusted Event Partner</h1>
//           <p className="mt-4 fw-light">
//             We bring expertise, creativity, and precision to every event,
//             ensuring seamless execution and unforgettable experiences.
//             From corporate conferences to grand celebrations, we handle every
//             detail. Trust us to transform your vision into a reality!
//           </p>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default HomeTitle;





import { useEffect, useState } from "react";
import HeroSection from "./HeroSection";
import axios from "../../axios";

function HomeTitle() {
  const [heroSlides, setHeroSlides] = useState([]);

  useEffect(() => {
    axios.get("/banners")
      .then((res) => {
        // console.log("Banner response:", res.data); // 👈 Add this
        const slides = res.data.map((banner) => {
          if (!banner.title) {
            return {
              image: banner.image_url,
              textLine1: "",
              textLine2: "",
            };
          }

          const words = banner.title.split(" ");
          return {
            image: banner.image_url,
            textLine1: words[0] || "",
            textLine2: words.slice(1).join(" ") || "",
          };
        });


        setHeroSlides(slides);
      })
    // .catch((err) => {
    //   console.error("Failed to load banners:", err);
    // });
  }, []);




  return (
    <div className="homepage bg-white mt-5 pt-5">
      <div>
        {heroSlides.length > 0 && <HeroSection images={heroSlides} />}
      </div>

      <section className="partner-section d-flex flex-column justify-content-center align-items-center text-center py-5">
        <div className="container bg-white home-title">
          <h1 className="fw-normal">Your Trusted Event Partner</h1>
          <p className="mt-4 fw-light">
            We bring expertise, creativity, and precision to every event,
            ensuring seamless execution and unforgettable experiences.
            From corporate conferences to grand celebrations, we handle every
            detail. Trust us to transform your vision into a reality!
          </p>
        </div>
      </section>
    </div>
  );
}

export default HomeTitle;

